<template>
    <div>
        <a href="#" @click="$emit('click', value)">
            {{ value.text }}
            #{{ value.category_id }}#
        </a>
        <div v-if="value.parent">
            <!--
            &gt; <ItemCategoryQueryResult v-model="value.parent" />
            -->
        </div>
    </div>
</template>

<script>
import ItemCategoryQueryResult from '@/components/ItemCategoryQueryResult'

export default {
    // https://stackoverflow.com/a/65034197
    name: 'ItemCategoryQueryResult',

    components: {
//        ItemCategoryQueryResult,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    methods: {
    },
}
</script>

<style>
</style>

